import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { catalogoData } from '../data';
import { useCart } from '../context/CartContext';
import toast from 'react-hot-toast';
import { ArrowLeft, Minus, Plus, ShoppingCart } from 'lucide-react';
import './ProductDetailPage.css';

const ProductDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addProduct } = useCart();
  
  // Buscar el producto por ID
  const product = catalogoData.find(p => p.id === parseInt(id));
  
  const [selectedPrice, setSelectedPrice] = useState(product?.precios[0]);
  const [quantity, setQuantity] = useState(1);

  if (!product) {
    return (
      <div className="product-detail-error">
        <h2>Producto no encontrado</h2>
        <button onClick={() => navigate('/catalogo')} className="btn-back">
          Volver al catálogo
        </button>
      </div>
    );
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value);
  };

  const handleAddToCart = () => {
    addProduct(product, quantity, selectedPrice);
    toast.success(
      `${quantity} x ${product.nombre} añadido!`,
      { icon: '🛒' }
    );
  };

  // Obtener productos relacionados de la misma categoría
  const relatedProducts = catalogoData
    .filter(p => p.categoria === product.categoria && p.id !== product.id)
    .slice(0, 3);

  return (
    <div className="product-detail-page">
      <div className="container">
        <button onClick={() => navigate('/catalogo')} className="btn-back">
          <ArrowLeft size={20} /> Volver al catálogo
        </button>

        <div className="product-detail-container">
          {/* Sección de imagen */}
          <div className="product-detail-image">
            <img src={product.imagen} alt={product.nombre} />
            <span className="product-category-badge">{product.categoria}</span>
          </div>

          {/* Sección de información */}
          <div className="product-detail-info">
            <h1 className="product-detail-title">{product.nombre}</h1>
            <p className="product-detail-description">{product.descripcion}</p>

            {/* Especificaciones */}
            <div className="product-specs">
              {product.peso && (
                <div className="spec">
                  <span className="spec-label">Peso:</span>
                  <span className="spec-value">{product.peso}</span>
                </div>
              )}
              {product.tamaño && (
                <div className="spec">
                  <span className="spec-label">Tamaño:</span>
                  <span className="spec-value">{product.tamaño}</span>
                </div>
              )}
            </div>

            {/* Selector de presentaciones */}
            <div className="pricing-section">
              <h3>Elige tu presentación:</h3>
              <div className="price-options">
                {product.precios.map((price, idx) => {
                  const label = price.presentacion || `${price.unidades} un.`;
                  return (
                  <div
                    key={idx}
                    className={`price-option ${selectedPrice === price ? 'active' : ''}`}
                    onClick={() => setSelectedPrice(price)}
                  >
                    <span className="units">{label}</span>
                    <span className="price">{formatCurrency(price.valor)}</span>
                  </div>
                  );
                })}
              </div>
            </div>

            {/* Controles de cantidad y carrito */}
            <div className="cart-controls">
              <div className="quantity-control">
                <label>Cantidad de presentaciones:</label>
                <div className="quantity-buttons">
                  <button onClick={() => setQuantity(q => Math.max(1, q - 1))}>
                    <Minus size={18} />
                  </button>
                  <input type="number" value={quantity} readOnly />
                  <button onClick={() => setQuantity(q => q + 1)}>
                    <Plus size={18} />
                  </button>
                </div>
              </div>

              <button className="btn-add-to-cart" onClick={handleAddToCart}>
                <ShoppingCart size={20} />
                Añadir al carrito
              </button>
            </div>

            {/* Resumen de compra */}
            <div className="purchase-summary">
              <p>
                <strong>Total:</strong> {formatCurrency(selectedPrice.valor * quantity)} 
                <span className="unit-price">({formatCurrency(selectedPrice.valor)} c/u)</span>
              </p>
            </div>
          </div>
        </div>

        {/* Productos relacionados */}
        {relatedProducts.length > 0 && (
          <div className="related-products">
            <h2>Productos similares</h2>
            <div className="related-grid">
              {relatedProducts.map(p => (
                <div
                  key={p.id}
                  className="related-card"
                  onClick={() => navigate(`/producto/${p.id}`)}
                >
                  <img src={p.imagen} alt={p.nombre} />
                  <h4>{p.nombre}</h4>
                  <p>{formatCurrency(p.precios[0].valor)}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetailPage;
